module.exports = __webpack_public_path__ + "media/images/banner_log-b1d792b5a6fbc6b5a3b0d532e18b4d2e.jpg";